import { TReservation } from "apis/meetings/meeting-reservation";

//* INFO: 시작 시간을 기준으로 30분 후의 시간을 반환
export const getDefaultEndTime = (startTime: Date) => {
  //* 만약, 시작 시간이 현재 시간보다 이전이라면, endTime은 현재시간 이후 30분으로 설정
  if (startTime.getTime() < new Date().getTime()) {
    const now = new Date();
    now.setMinutes(now.getMinutes() + 30);
    return now;
  }

  //* 만약, 시작 시간이 현재 시간보다 이후라면, endTime은 시작시간 이후 30분으로 설정
  const hour = startTime.getMinutes() > 30 ? startTime.getHours() + 1 : startTime.getHours();
  const minutes = startTime.getMinutes() === 0 ? 0 : startTime.getMinutes() < 30 ? 30 : 0;
  const initDate = new Date(startTime);
  initDate.setHours(hour, minutes);
  return initDate;
};

//* INFO: 현재 시간의 scroll 위치를 반환
export const getScrollPosition = () => {
  const now = new Date();
  const nowHour = now.getHours();
  const nowMinute = now.getMinutes();
  if (nowHour <= 7 || nowHour >= 23) return 0;
  const nowIndex = (nowHour - 7) * 2 + (nowMinute > 0 ? 1 : 0) - 1;
  return nowIndex * 28;
};

//* INFO: 예약 중복 여부를 확인하는 함수/ selectedRsv는 수정 중인 예약을 의미 / 수정 중인 예약은 중복 체크에서 제외
export const checkOverlap = (
  selectedStartTime: Date,
  selectedEndTime: Date,
  reservationList: TReservation[],
  selectedRsv?: TReservation
) => {
  return reservationList?.some((item) => {
    const rsvStartTime = new Date(item.startTime);
    const rsvEndTme = new Date(item.endTime);
    const startTime = new Date(selectedStartTime);
    const endTime = new Date(selectedEndTime);

    startTime.setHours(rsvStartTime.getHours(), rsvStartTime.getMinutes(), 0, 0);
    endTime.setHours(rsvEndTme.getHours(), rsvEndTme.getMinutes(), 0, 0);

    if (!item.id) {
      //* Google 예약 위젯일 경우, id 값이 없으므로, googleEventId로 같은 rsv인지 확인
      if (selectedRsv && selectedRsv.googleEventId === item.googleEventId) return false;
    } else if (selectedRsv && selectedRsv.id === item.id) return false;

    const isOverlap =
      (selectedStartTime.getTime() >= startTime.getTime() && selectedStartTime.getTime() < endTime.getTime()) ||
      (selectedEndTime.getTime() > startTime.getTime() && selectedEndTime.getTime() <= endTime.getTime()) ||
      (selectedStartTime.getTime() < startTime.getTime() && selectedEndTime.getTime() > endTime.getTime());

    return isOverlap;
  });
};

export const startTimeToIndex = (date: Date): number => {
  const hours = date.getHours();
  const minutes = date.getMinutes();

  const startOffset = minutes < 30 ? 0 : 1;
  const startIndex = (hours - 7) * 2 + startOffset;

  return startIndex;
};

export const endTimeToIndex = (date: Date): number => {
  const hours = date.getHours();
  const minutes = date.getMinutes();

  if (minutes > 0 && minutes <= 30) {
    return (hours - 7) * 2 + 1;
  } else if (minutes > 30) {
    return (hours - 7) * 2 + 2;
  } else {
    return (hours - 7) * 2;
  }
};

//* selectedTime의 값으로 타임블록의 위치와 높이를 계산
export const getSelectedTimeBlockIndex = (startDate: Date, endDate: Date) => {
  const startIndex = startTimeToIndex(startDate);
  const endIndex = startIndex === 31 ? 32 : Math.min(32, endTimeToIndex(endDate));

  return { top: startIndex * 28, height: (endIndex - startIndex) * 28 };
};
